module.exports = __webpack_public_path__ + "f3374d733e20eaab33e54a51bb2ade05.svg";